import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Zap } from 'lucide-react';
import { supabase } from '../lib/supabase';

const AuthCallbackPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) {
        navigate('/', { replace: true });
      } else {
        navigate('/login', { replace: true });
      }
    });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-bolt-bg flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="w-10 h-10 bg-primary-600 rounded-xl flex items-center justify-center animate-pulse">
          <Zap className="h-5 w-5 text-white" fill="currentColor" />
        </div>
        <p className="text-sm text-bolt-textMuted">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallbackPage;
